export const ApplicantTitleHonorifics = [
  {
    value: "Mr",
    title: "Mr",
  },
  {
    value: "Miss",
    title: "Miss",
  },
  {
    value: "Mrs",
    title: "Mrs",
  },
  {
    value: "Ms",
    title: "Ms",
  },
  {
    value: "Mx",
    title: "Mx",
  },
  {
    value: "Dr",
    title: "Dr",
  },
  {
    value: "Other",
    title: "Other",
  },
];
